import { theme } from '../../../styles';
import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const InfoIcon = ({
  marginLeft,
  marginRight,
  width = 15,
  containerSize,
  variant = 'dark',
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
      <g fill="none" fillRule="evenodd">
        <path
          fill={getSemanticTextColor(variant === 'dark' ? 'foraBlue' : 'white')}
          stroke={getSemanticTextColor(variant === 'dark' ? 'foraBlue' : 'white')}
          d="M7.5 14A6.493 6.493 0 0 1 1 7.5C1 3.904 3.905 1 7.5 1 11.096 1 14 3.904 14 7.5S11.096 14 7.5 14z"
        />
        <path
          stroke={variant === 'dark' ? theme.colors.white : theme.colors.foraBlue}
          strokeLinecap="round"
          strokeWidth="2"
          d="M7.5 7.5v3.25"
        />
        <circle cx="7.5" cy="4" r="1" fill={variant === 'dark' ? theme.colors.white : theme.colors.foraBlue} />
      </g>
    </svg>
  </DefaultIconWrapper>
);
